// extracted by mini-css-extract-plugin
module.exports = {"dataTableFormat":"styles_dataTableFormat__3CR4n","formSpace":"styles_formSpace__1pYzB","actionButton":"styles_actionButton__3t35g","actionIcon":"styles_actionIcon__2MBv-"};